
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class SKULaborGrid extends Serenity.EntityGrid<SKULaborRow, any> {
        protected getColumnsKey() { return 'Inventory.SKULabor'; }
        protected getDialogType() { return SKULaborDialog; }
        protected getIdProperty() { return SKULaborRow.idProperty; }
        protected getInsertPermission() { return SKULaborRow.insertPermission; }
        protected getLocalTextPrefix() { return SKULaborRow.localTextPrefix; }
        protected getService() { return SKULaborService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}